import { useLocalExportBuildEYPptx } from "../local_export_build_ey_pptx/local_export_build_ey_pptx";
import localExportBuildKpmgPptx from "../local_export_build_kpmg_pptx";
import localExportBuildPptx from "../local_export_build_pptx";
import { EYPptxPreview } from "../parts/ey_pptx_preview/ey_pptx_preview";
import KpmgPptxPreview from "../parts/kpmg_pptx_preview";
import PptxPreview from "../parts/pptx_preview";

const KPMG_TEMPLATES = ["kpmg_resume", "kpmg_ca_resume", "kpmg_ca_french_resume"];
const EY_TEMPLATES = ["ey_resume_pptx"];

export const isEY = (templateKey) => EY_TEMPLATES.includes(templateKey);
export const isKPMGCAFrench = (templateKey) => templateKey === KPMG_TEMPLATES[2];
export const isKPMGCA = (templateKey) =>
  templateKey === KPMG_TEMPLATES[1] || templateKey === KPMG_TEMPLATES[2];

export const getLocalExportBuildPptx = (templateKey) => {
  if (KPMG_TEMPLATES.includes(templateKey)) {
    return localExportBuildKpmgPptx;
  } else if (isEY(templateKey)) {
    return useLocalExportBuildEYPptx;
  } else {
    return localExportBuildPptx;
  }
};

export const getPptxPreviewComponent = (templateKey) => {
  if (KPMG_TEMPLATES.includes(templateKey)) {
    return KpmgPptxPreview;
  } else if (isEY(templateKey)) {
    return EYPptxPreview;
  } else {
    return PptxPreview;
  }
};

export const getTranslationKey = (templateKey) => {
  if (isEY(templateKey)) {
    return "eyPptx";
  }
  return isKPMGCAFrench(templateKey) ? "kpmgFrPptx" : "kpmgPptx";
};

export const EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL = ["education", "qualifications"];
export const EY_CERTIFICATES_FIELD_NAMES_OTHER = [
  "accreditations",
  "certificates",
  "licenses_and_certifications",
  "ey_certificates",
  "prof_qualification",
  "memberships"
];
export const EY_CERTIFICATES_FIELD_NAMES = [
  ...EY_CERTIFICATES_FIELD_NAMES_EDUCATIONAL,
  ...EY_CERTIFICATES_FIELD_NAMES_OTHER
];
export const getKPMGClientsFieldNames = (templateKey) => [isKPMGCA(templateKey) ? "brands" : "clients"];
export const getKPMGQualificationsFieldNames = (templateKey) =>
  isKPMGCA(templateKey)
    ? ["major", "degree", "licenses_certifications"]
    : ["certificates", "qualifications", "licenses_and_certifications"];
